module.exports = __webpack_public_path__ + "static/media/AboutContent-1.bf771287.png";